import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { container } from '@/app/container';
import { SalesRepositoryToken } from '../../di/tokens';
import type { ListContractsInput } from '../../data/datasources/sales-api.datasource';

type QueryFilters = Omit<ListContractsInput, 'page' | 'perPage'>;

/**
 * Lista paginada de contratos (página de Contratos), ordenada por updatedAt
 * desc. Mesma disciplina de `useTransactions`: os filtros vão como query param
 * e compõem a `queryKey`.
 */
export function useContracts(
  page = 1,
  perPage = 10,
  filters: QueryFilters = {},
) {
  const repository = container.resolve(SalesRepositoryToken);
  return useQuery({
    queryKey: ['sales', 'contracts', page, perPage, filters],
    queryFn: () => repository.listContracts({ page, perPage, ...filters }),
    staleTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
  });
}
